import {observer} from "mobx-react";
import {AudioExampleModel} from "../../shared/models/AudioTestModel";
import React, {useEffect, useRef} from "react";
import Grid from "@material-ui/core/Grid";
import {SurveyControlRender} from "../forms/SurveyControl.render";
import {AudioButton, AudioController, useAudioPlayer} from "../web-audio/AudiosPlayer";
import {AudioLoading, useAllAudioRefsReady} from "../web-audio/AudiosLoading";

export const AudioTestItemTraining = observer(function (props: { value: AudioExampleModel, active?: boolean, onAudioLoadingChange?: (loading: boolean) => void }) {
  const {value, active, onAudioLoadingChange} = props;
  const {
    refs,
    activeRef,
    currentTime,
    handleTimeUpdate,
    handlePlay,
    handlePause,
    handleEnded,
    handleSeek,
  } = useAudioPlayer(value.medias, undefined, value, false);
  const {loading, loadError, progress, sources, retry} = useAllAudioRefsReady(refs, value.medias, active !== false);
  const completedClips = useRef(new Set<number>());

  useEffect(() => {
    if (active === false) handlePause();
  }, [active]);

  const markClipCompleted = (index: number) => {
    completedClips.current.add(index);
    if (completedClips.current.size === value.medias.length) value.playedOnce = true;
  };

  const handleTrainingTimeUpdate = (index: number) => {
    handleTimeUpdate();
    const audio = refs[index]?.current;
    // Whole-track loops use the native `loop` property and therefore do not
    // emit `ended`; record completion shortly before that native wrap.
    if (audio && Number.isFinite(audio.duration) && audio.currentTime >= audio.duration - 0.05)
      markClipCompleted(index);
  };

  return <>
    <AudioLoading showing={loading} error={loadError} progress={progress} onRetry={retry} onLoadingChange={onAudioLoadingChange}/>
    <Grid container spacing={2} style={{display: loading || loadError ? 'none' : 'flex'}}>
    {/*Description for the example*/}
    {value.fields && value.fields[0] && <Grid item xs={12}>
      <SurveyControlRender control={value.fields[0]}/>
    </Grid>}
    {value.medias.map((v, i) => <Grid item key={i}>
      <AudioButton ref={refs[i]} audio={v} source={sources[v.src]} load={active !== false} onPlay={handlePlay} onPause={handlePause}
                   onEnded={() => {
                     markClipCompleted(i);
                     handleEnded();
                   }} onTimeUpdate={() => handleTrainingTimeUpdate(i)}>{i + 1}</AudioButton>
    </Grid>)}
    {/*Slider bar of player */}
    <Grid item xs={12}>
      <AudioController activeRef={activeRef} currentTime={currentTime} onSeek={handleSeek}
                       disabled={value.settings?.disablePlayerSlider}/>
    </Grid>
    {/*Ask a question for training*/}
    {value.fields?.slice(1).map((v, i) => <Grid item xs={12} key={i}>
      <SurveyControlRender control={v}/>
    </Grid>)}
    </Grid>
  </>
})
